import { useCallback, useMemo, useState } from 'react'
import { useGalleryConstants, useGalleryDeal } from '../../../../_main/contexts'

import constate from 'constate'
import { useGalleryStagingFlow } from './GalleryStagingFlow.context'

export const [GalleryStagingFlowListContextProvider, useGalleryStagingFlowList] = constate(() => {

  const { stagingAssignments } = useGalleryDeal()
  const { stagingAssignmentId, assignmentsToStage, setAssignmentsToStage, stagingRequestState } = useGalleryStagingFlow()
  const { stagesUnlockingStagingFlow } = useGalleryConstants()

  const [finishedStagings, setFinishedStagings] = useState<Set<string>>(new Set([]))
  const [skipStaging, setSkipStaging] = useState(false)

  const hasStaging = useMemo(() => assignmentsToStage.length > 0, [assignmentsToStage.length])
  const isStagingFinished = useMemo(() => skipStaging || assignmentsToStage.length === finishedStagings.size, [assignmentsToStage.length, finishedStagings.size, skipStaging])
  const remainingStagingsCount = useMemo(() => assignmentsToStage.length - finishedStagings.size, [assignmentsToStage.length, finishedStagings.size])

  /** Initialize context with filtered assignments ready for staging */
  const initializeStagingListing = useCallback(() => {
    const assignmentsToSet = stagingAssignments.filter((assignment) => stagesUnlockingStagingFlow.has(assignment.stage))
    setAssignmentsToStage(assignmentsToSet)
  }, [setAssignmentsToStage, stagesUnlockingStagingFlow, stagingAssignments])

  /** Resets staging data */
  const resetStaging = () => {
    setAssignmentsToStage([])
    setFinishedStagings(new Set([]))
    setSkipStaging(false)
  }

  return {
    hasStaging,
    isStagingFinished,
    stagingRequestState,
    finishedStagings,
    assignmentsToStage,
    remainingStagingsCount,
    skipStaging,
    setFinishedStagings,
    initializeStagingListing,
    resetStaging,
    setSkipStaging,
  }

})
